import { HttpClient } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { HotelService } from 'src/app/services/hotel.service';

@Injectable({
    providedIn: 'root',
})

export class TOPDestinations{
constructor(private http: HttpClient, public hotService: HotelService) { }
    popularCanadaLocations=[
  {
    id: "472776",
    name: "Toronto, Ontario",
    fullName: "Toronto, Ontario, Canada",
    type: "multiCity",
    state: "Peel Regional Municipality",
    country: "CA",
    score: 0,
    coordinates: {
      lat:43.6484,
      long:-79.38217
    }    
  },
    {
     id: "476724",
      name: "Quebec",
      fullName: "Quebec, Quebec, Canada",
      type: "city",
      state: "Capitale-Nationale",
      country: "CA",
      score: 0,
      coordinates: {
        lat: 46.8104,
        long: -71.2139
      }  
    },
    {
      id: "476713",
      name: "Vancouver",
      fullName: "Vancouver, British Columbia, Canada",
      type: "city",
      state: "British Columbia",
      country: "CA",
      score: 0,
      coordinates: {
        lat: 49.28313,
        long: -123.11903
      }      
    },
    {
      id: "472679",
      name: "Calgary",
      fullName: "Calgary, Alberta, Canada",
      type: "multiCity",
      state: "Foothills County",
      country: "CA",
      score: 0,
      coordinates: {
        lat: 51.04832,
        long: -114.06999
      }
    },
    {
      id: "472790",
      name: "Ottawa",
      fullName: "Ottawa, Ontario, Canada",
      type: "multiCity",
      state: "Papineau Regional County Municipality",
      country: "CA",
      score: 0,
      coordinates: {
        lat: 45.42052,
        long: -75.69975
      }
      
    },
    
    {
      id: "472773",
      name: "Montreal",
      fullName: "Montreal, Quebec, Canada",
      type: "Country",
      country: "CA",
      score: 0,
      coordinates: {
        lat: 45.50195,
        long: -73.56714
      }
      
    },
    {
    id: "472678",
      name: "Victoria",
      fullName: "Victoria, British Columbia, Canada",
      type: "MultiCity",
      state: "Capital",  
      country: "CA",
      score: 0,
      coordinates: {
        lat: 48.42783,
        long: -123.36436
      }
        
    },
    {
      id: "473359",
      name: "St. John's",
      fullName: "St. John's, Newfoundland and Labrador, Canada",
      type: "MultiCity",
      state: "Newfoundland",
      country: "CA",
      score: 0,
      coordinates: {
        lat: 47.560287,
        long: -52.712578
      } 
      
    },
    
    {
      id: "476676",
      name: "Thunder Bay",
      fullName: "Thunder Bay, Ontario, Canada",
      type: "city",
      state: "Ontario",
      country: "CA",
      score: 0,
      coordinates: {
        lat: 48.423485,
        long: -89.2992
      }
    },
    {
      id: "484776",
      name: "Banff",
      fullName: "Banff, Alberta, Canada",
      type: "city",
      state: "Alberta",
      country: "CA",
      score: 0,
      coordinates: {
        lat: 51.17736,
        long: -115.57075
      }
    },
    {
      id: "501853",
      name: "Winnipeg",
      fullName: "Winnipeg, Manitoba, Canada",
      type: "city",
      state: "Division No. 11",
      country: "CA",
      score: 0,
      coordinates: {
        lat: 49.875088,
        long: -97.16414
      }
    }
      ]

    popularAvolarLocations=[
      {
        id: "652057",
        name: "Punta Cana",
        fullName: "Punta Cana, Dominican Republic",
        type: "MultiCity",
        state: "La Altagracia",
        country: "DO",
        score: 0,
        coordinates: {
          lat: 18.59386,
          long: -68.38268
        }        
      },
      {
        id: "472688",
        name: "Orlando",
        fullName: "Orlando, Florida, United States of America",
        type: "MultiCity",
        country: "US",
        score: 0,
        coordinates: {
          lat: 28.54129,
          long: -81.37904
        }
        
      },
      {
       id: "606538",
        name: "Cancun",
        fullName: "Cancun, Quintana Roo, Mexico",
        type: "City",
        state: "Benito Juárez",
        country: "MX",
        score: 0,
        coordinates: {
          lat: 21.16362,
          long: -86.82578
        }  
      },
      {
        id: "472764",
        name: "New York",
        fullName: "New York, New York, United States of America",
        type: "MultiCity",
        state: "Queens County",
        country: "US",
        score: 0,
        coordinates: {
          lat: 40.75668,
          long: -73.98647
        } 
        
      },
      {
        id: "472683",
        name: "Las Vegas",
        fullName: "Las Vegas, Nevada, United States of America",
        type: "City",
        state: "Clark County",
        country: "US",
        score: 0,
        coordinates: {
          lat: 36.114666,
          long: -115.172874
        }
      },
      {
        id: "118343",
        name: "Barcelona",
        fullName: "Barcelona, Spain",
        type: "MultiCity",
        state: "Valles Occidental",
        country: "ES",
        score: 0,
        coordinates: {
          lat: 41.37785,
          long: 2.17055
        }
        
      },      
      {
        id: "118416",
        name: "Madrid",
        fullName: "Madrid, Spain",
        type: "multiCity",
        state: "Cuenca del Henares",
        country: "ES",
        score: 0,
        coordinates: {
          lat: 40.417007,
          long: -3.703565
        }        
      }
     
      ]
}